var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer"},[_vm._t("default")],2),_c('div',{staticClass:"footer-block"})])}
var staticRenderFns = []

export { render, staticRenderFns }